import { render } from "./main-info.vue?vue&type=template&id=785a28f9"
import script from "./main-info.vue?vue&type=script&lang=js"
export * from "./main-info.vue?vue&type=script&lang=js"

import "./main-info.vue?vue&type=style&index=0&id=785a28f9&lang=less"

import exportComponent from "/Users/jiaxibei/Desktop/bilibiliProjects/ProfessProject/campus-activity-toc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__